import { DataStorage } from "core/Misc/dataStorage";
import { Observable } from "core/Misc/observable";
/**
 * The unique identity symbol for the settings store service.
 */
export const SettingsStoreIdentity = Symbol("SettingsStore");
function GetKey(namespace, settingKey) {
    return `Babylon/${namespace}/${settingKey}`;
}
/**
 * Default implementation of {@link ISettingsStore} that persists settings using browser local storage.
 */
export class SettingsStore {
    /**
     * Creates a new settings store.
     * @param _namespace A namespace used to scope the settings keys to avoid collisions with other stores.
     */
    constructor(_namespace) {
        this._namespace = _namespace;
        this._onChanged = new Observable();
    }
    get onChanged() {
        return this._onChanged;
    }
    readSetting(descriptor) {
        const key = GetKey(this._namespace, descriptor.key);
        return DataStorage.ReadJson(key, descriptor.defaultValue);
    }
    writeSetting(descriptor, value) {
        const key = GetKey(this._namespace, descriptor.key);
        DataStorage.WriteJson(key, value);
        this._onChanged.notifyObservers(descriptor.key);
    }
}
//# sourceMappingURL=settingsStore.js.map